(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["GEO-WHOLESALE-NATURAL-STONE-JEWELRY"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /*
    Bind once globally.
    The guide may not exist on every collection page, so delegated events
    allow Shopify section reloads without duplicate listeners.
  */
  if (window.mddNSWholesaleGuideV1Bound) return;
  window.mddNSWholesaleGuideV1Bound = true;

  var guideSelector = '[data-mdd-ns-guide]';

  function targetFromHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;

    var id;

    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return null;
    }

    var target = document.getElementById(id);

    return target && target.closest(guideSelector) ? target : null;
  }


  function reveal(target, shouldScroll, shouldFocus, animate) {
    if (!target) return;

    var guide = target.closest(guideSelector);
    var details = target.closest('details');

    while (details && guide.contains(details)) {
      details.open = true;
      details = details.parentElement.closest('details');
    }

    if (!shouldScroll) return;

    window.requestAnimationFrame(function () {
      if (!target.isConnected) return;

      var reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (shouldFocus) {
        target.focus({ preventScroll: true });
      }

      target.scrollIntoView({
        behavior: animate && !reduceMotion ? 'smooth' : 'auto',
        block: 'start'
      });
    });
  }


  function revealCurrentHash(shouldScroll) {
    reveal(
      targetFromHash(window.location.hash),
      shouldScroll,
      false,
      false
    );
  }


  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    if (!(event.target instanceof Element)) return;

    var link = event.target.closest(
      '[data-mdd-ns-guide] .mdd-ns-supergeo__toc a[href^="#"]'
    );

    if (!link) return;

    var target = targetFromHash(link.getAttribute('href'));
    var guide = link.closest(guideSelector);

    if (!target || !guide.contains(target)) return;

    event.preventDefault();

    /*
      Intentionally do not rewrite URLs, UTM parameters,
      browser history or conversion tracking.
    */
    reveal(target, true, true, true);
  });


  window.addEventListener('hashchange', function () {
    revealCurrentHash(true);
  });


  document.addEventListener('shopify:section:load', function () {
    revealCurrentHash(false);
  });


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        revealCurrentHash(true);
      },
      { once: true }
    );
  } else {
    revealCurrentHash(true);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["GEO-WHOLESALE-STAINLESS-JEWELRY-V2"] && !Shopify.designMode) return;
  try {
    (function () {

  'use strict';

  // Shopify bundles this snippet script. Bind once, including when no guide

  // is present yet, so delegated clicks work after later section updates.

  if (window.mddSSWholesaleGuideV12Bound) return;

  window.mddSSWholesaleGuideV12Bound = true;

  var guideSelector = '[data-mdd-ss-guide]';

  function targetFromHash(hash) {

    if (!hash || hash.charAt(0) !== '#') return null;

    var id;

    try {

      id = decodeURIComponent(hash.slice(1));

    } catch (error) {

      return null;

    }

    var target = document.getElementById(id);

    return target && target.closest(guideSelector) ? target : null;

  }

  function reveal(target, shouldScroll, shouldFocus, animate) {

    if (!target) return;

    var guide = target.closest(guideSelector);

    var details = target.closest('details');

    while (details && guide.contains(details)) {

      details.open = true;

      details = details.parentElement.closest('details');

    }

    if (!shouldScroll) return;

    window.requestAnimationFrame(function () {

      if (!target.isConnected) return;

      var reduceMotion = window.matchMedia(

        '(prefers-reduced-motion: reduce)'

      ).matches;

      if (shouldFocus) {

        target.focus({ preventScroll: true });

      }

      target.scrollIntoView({

        behavior: animate && !reduceMotion ? 'smooth' : 'auto',

        block: 'start'

      });

    });

  }

  function revealCurrentHash(shouldScroll) {

    reveal(

      targetFromHash(window.location.hash),

      shouldScroll,

      false,

      false

    );

  }

  document.addEventListener('click', function (event) {

    if (

      event.defaultPrevented ||

      event.button !== 0 ||

      event.metaKey ||

      event.ctrlKey ||

      event.shiftKey ||

      event.altKey

    ) {

      return;

    }

    if (!(event.target instanceof Element)) return;

    var link = event.target.closest(

      '[data-mdd-ss-guide] .mdd-ss-supergeo__toc a[href^="#"]'

    );

    if (!link) return;

    var target = targetFromHash(link.getAttribute('href'));

    var guide = link.closest(guideSelector);

    if (!target || !guide.contains(target)) return;

    event.preventDefault();

    // Do not rewrite URLs, UTM parameters, history, or conversion tracking.

    reveal(target, true, true, true);

  });

  window.addEventListener('hashchange', function () {

    revealCurrentHash(true);

  });

  document.addEventListener('shopify:section:load', function () {

    revealCurrentHash(false);

  });

  if (document.readyState === 'loading') {

    document.addEventListener(

      'DOMContentLoaded',

      function () {

        revealCurrentHash(true);

      },

      { once: true }

    );

  } else {

    revealCurrentHash(true);

  }

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["geo-anti-tarnish-footer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (window.mddAntiTarnishGuideV2Bound) return;
  window.mddAntiTarnishGuideV2Bound = true;

  var guideSelector = '[data-mdd-at-guide]';

  function targetFromHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;

    var id;

    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return null;
    }

    var target = document.getElementById(id);

    return target && target.closest(guideSelector) ? target : null;
  }

  function reveal(target, shouldScroll, shouldFocus, animate) {
    if (!target) return;

    var guide = target.closest(guideSelector);
    var details = target.closest('details');

    while (details && guide.contains(details)) {
      details.open = true;
      details = details.parentElement.closest('details');
    }

    if (!shouldScroll) return;

    window.requestAnimationFrame(function () {
      if (!target.isConnected) return;

      var reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (shouldFocus) {
        target.focus({ preventScroll: true });
      }

      target.scrollIntoView({
        behavior: animate && !reduceMotion ? 'smooth' : 'auto',
        block: 'start'
      });
    });
  }

  function revealCurrentHash(shouldScroll) {
    reveal(
      targetFromHash(window.location.hash),
      shouldScroll,
      false,
      false
    );
  }

  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    if (!(event.target instanceof Element)) return;

    var link = event.target.closest(
      '[data-mdd-at-guide] .mdd-at-supergeo__toc a[href^="#"]'
    );

    if (!link) return;

    var target = targetFromHash(link.getAttribute('href'));
    var guide = link.closest(guideSelector);

    if (!target || !guide.contains(target)) return;

    event.preventDefault();

    reveal(target, true, true, true);
  });

  window.addEventListener('hashchange', function () {
    revealCurrentHash(true);
  });

  document.addEventListener('shopify:section:load', function () {
    revealCurrentHash(false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        revealCurrentHash(true);
      },
      { once: true }
    );
  } else {
    revealCurrentHash(true);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["geo-pvd-gold-footer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  // Shopify bundles this snippet script. Bind once, including when no guide
  // is present yet, so delegated clicks work after later section updates.
  if (window.mddPvdWholesaleGuideV12Bound) return;
  window.mddPvdWholesaleGuideV12Bound = true;

  var guideSelector = '[data-mdd-pvd-guide]';

  function targetFromHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return null;
    }
    var target = document.getElementById(id);
    return target && target.closest(guideSelector) ? target : null;
  }

  function reveal(target, shouldScroll, shouldFocus, animate) {
    if (!target) return;
    var guide = target.closest(guideSelector);
    var details = target.closest('details');

    while (details && guide.contains(details)) {
      details.open = true;
      details = details.parentElement.closest('details');
    }

    if (!shouldScroll) return;
    window.requestAnimationFrame(function () {
      if (!target.isConnected) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (shouldFocus) target.focus({ preventScroll: true });
      target.scrollIntoView({
        behavior: animate && !reduceMotion ? 'smooth' : 'auto',
        block: 'start'
      });
    });
  }

  function revealCurrentHash(shouldScroll) {
    reveal(targetFromHash(window.location.hash), shouldScroll, false, false);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey ||
        event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    var link = event.target.closest(
      '[data-mdd-pvd-guide] .mdd-pvdgeo__toc a[href^="#"]'
    );
    if (!link) return;
    var target = targetFromHash(link.getAttribute('href'));
    var guide = link.closest(guideSelector);
    if (!target || !guide.contains(target)) return;

    event.preventDefault();
    // Do not rewrite URLs, UTM parameters, history, or conversion tracking.
    reveal(target, true, true, true);
  });

  window.addEventListener('hashchange', function () {
    revealCurrentHash(true);
  });

  document.addEventListener('shopify:section:load', function () {
    revealCurrentHash(false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      revealCurrentHash(true);
    }, { once: true });
  } else {
    revealCurrentHash(true);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["geo-ring-footer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  // Shared ring snippet: install once. Delegation survives replaced HTML.
  if (window.mddSSRingGuideV1Bound) return;
  window.mddSSRingGuideV1Bound = true;

  var guideSelector = '[data-mdd-ss-ring-guide]';

  function targetFromHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return null;
    }
    if (id.indexOf('mdd-sr-') !== 0) return null;
    var target = document.getElementById(id);
    return target && target.closest(guideSelector) ? target : null;
  }

  function reveal(target, shouldScroll, shouldFocus, animate) {
    if (!target) return;
    var guide = target.closest(guideSelector);
    var details = target.closest('details');
    while (details && guide.contains(details)) {
      details.open = true;
      details = details.parentElement.closest('details');
    }
    if (!shouldScroll) return;
    window.requestAnimationFrame(function () {
      if (!target.isConnected) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (shouldFocus) target.focus({ preventScroll: true });
      target.scrollIntoView({
        behavior: animate && !reduceMotion ? 'smooth' : 'auto',
        block: 'start'
      });
    });
  }

  function revealCurrentHash(shouldScroll) {
    reveal(targetFromHash(window.location.hash), shouldScroll, false, false);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey ||
        event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest(
      '[data-mdd-ss-ring-guide] .mdd-ss-ringgeo__toc a[href^="#"]'
    );
    if (!link) return;
    var target = targetFromHash(link.getAttribute('href'));
    var guide = link.closest(guideSelector);
    if (!target || !guide.contains(target)) return;
    event.preventDefault();
    // No URL rewriting, analytics calls, cookie writes, or history changes.
    reveal(target, true, true, true);
  });

  window.addEventListener('hashchange', function () {
    revealCurrentHash(true);
  });
  document.addEventListener('shopify:section:load', function () {
    revealCurrentHash(false);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      revealCurrentHash(true);
    }, { once: true });
  } else {
    revealCurrentHash(true);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["geo-waterproof-footer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (window.mddWaterproofGuideV2Bound) return;
  window.mddWaterproofGuideV2Bound = true;

  var guideSelector = '[data-mdd-wp-guide]';

  function targetFromHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    var id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (error) { return null; }
    var target = document.getElementById(id);
    return target && target.closest(guideSelector) ? target : null;
  }

  function reveal(target, shouldScroll, shouldFocus, animate) {
    if (!target) return;
    var guide = target.closest(guideSelector);
    var details = target.closest('details');

    while (details && guide.contains(details)) {
      details.open = true;
      details = details.parentElement.closest('details');
    }

    if (!shouldScroll) return;

    window.requestAnimationFrame(function () {
      if (!target.isConnected) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (shouldFocus) target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: animate && !reduceMotion ? 'smooth' : 'auto', block: 'start' });
    });
  }

  function revealCurrentHash(shouldScroll) {
    reveal(targetFromHash(window.location.hash), shouldScroll, false, false);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    var link = event.target.closest('[data-mdd-wp-guide] .mdd-wp-supergeo__toc a[href^="#"]');
    if (!link) return;

    var target = targetFromHash(link.getAttribute('href'));
    var guide = link.closest(guideSelector);
    if (!target || !guide.contains(target)) return;

    event.preventDefault();
    reveal(target, true, true, true);
  });

  window.addEventListener('hashchange', function () { revealCurrentHash(true); });
  document.addEventListener('shopify:section:load', function () { revealCurrentHash(false); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { revealCurrentHash(true); }, { once: true });
  } else {
    revealCurrentHash(true);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
